import {VueReCaptcha} from "vue-recaptcha-v3";

export default vue => {
    vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_KEY })
}
